export const  InconelGradeData=[

    {
      id:1,
      grade:'Inconel 600 Sheets & Plates',
      link:'/Inconel600Grade'
    },
    {
      id:2,
      grade:'Inconel 601 Sheets & Plates',
      link:'/Inconel601Grade'
    },
    {
      id:3,
      grade:'Inconel 625 Sheets & Plates',
      link:'/Inconel625Grade'
    },
    
    {
      id:4,
      grade:'Inconel 718 Sheets & Plates'
      ,
      link:'/Inconel718Grade'
    },
    {
      id:5,
      grade:' Inconel 750 Sheets & Plates',
      link:'/Inconel750Grade'
    },
    {
      id:6,
      grade:'Inconel 706 Sheets & Plates',
      link:'/Inconel706Grade'
    },
    {
        id:7,
        grade:'Inconel RA330 Sheets & Plates',
        link:'/InconelRA330Grade'
      },
]

export const InconelSheetData=[

    {
        text1:'Inconel Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
        test2:'Modi Metals offers an expansive get-together of these Inconel Alloy Sheets, Plates in various estimations and sizes. We about offer these things in various assessments, for example, Inconel Sheets Plates. We hold bowed in offering our customers a superb show of these Inconel Sheets that are acclaimed for its high check and wide – estimation of occupations.',
        text3:'Modi Metals. is a remarkable connection that is routinely occupied with offering a wide segment of Inconel Sheet, Plates and Coils. We offer a vivacious component of Inconel Sheets in the business. With some hair-raising highlights like having Consistent errand, Easy to keep up, Ruggedly created, and that is only a gander at something dynamically significant, the offered Inconel Alloy Sheets are given in various estimations with smooth completing which suits the clients needs completely.',
        Specifications:
{
    Specifications : 'ASTM / ASME SB 168',
Size : '1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm',
Thickness : '0.01 mm to 250 mmThk',
Form : "Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
Hardness : 'Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.'
}

    ,
        applications:['Off-Shore Oil Drilling Companies',
            'Power Generation',
           ' Petrochemicals',
            'Gas Processing',
            'Specialty Chemicals',
         'Pharmaceutical',
          'EquipmentSea Water',
            'EquipmentPulp and Paper Industry']


    }
]


export const Inconel601Data=[


    {
      text1:'Inconel 601 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'Inconel UNS N06601 Plates, Inconel Alloy 601 Sheets, ASME SB 168 Inconel 601 Plate, JIS NCF 601 Plate, 601 Inconel Hot Rolled Plates Supplier In Mumbai, India. Inconel 601 Cold Rolled Plates, 601 Alloy Plate Exporter, ASTM B 168 Inconel 601 Shim Sheets, Inconel 601 Slatting Coil, Inconel Werkstoff No 2.4851 Sheets, Inconel 601 Sheets Dealer In India. 601 Inconel Plate Stockholder, 601 Inconel Polished Cold Drawn Plates, Distributors Of ASME SB168 Inconel 601 Coils, Inconel GOST XH60BT Strips Stockist, Manufacturer.',
      text3:"Nickel-Alloy 601 Plates is what's increasingly utilized for combustor parts and drive mastermind bolsters in apparatus for nitric hurting age. These Nickel-Alloy 601 Coils are in addition utilized in cases, plate, and mechanical social events for warmth – treating gear. Enormous demulcents Inconel UNS N06601 Sheets Plates are utilized for tapping, infiltrating, underwriting or debilitating. In the mean time, these Alloy 601 Plates are in like way being offered in various sizes and shapes to our clients.",
  
      Specifications:
        {
            Specifications : "ASTM / ASME SB 168",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.01 mm to 250 mmThk",
            Form : "Coils, Foils, Rolls, Plain Sheet, Shim Sheet, Strip, Flats, Blank (Circle), Ring (Flange)",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc."
        }
      ,
      
      
      chemical:
     
        {
          Grade:'Inconel 601',
          c:'0.10 max',
          Mn:'1.00 max',
          Si:'0.50 max',
          P:'0.060 max',
          S:'0.015max',
          Cr:'21.0 – 25.0',
          Fe:'Balance',
          Ni:'58.0 – 63.0',
          Cu:'1.00 max',
          
        }
      ,
      
    },
   
  ]

  export const Inconel600Data=[


    {
      text1:'Inconel 600 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'ASTM B168 Inconel Sheet, Plates Manufacturer At India, Werkstoff No 2.4816 Inconel Structurals Exporter, Inconel 600 Hot Rolled Plates, Alloy 600 Chequered Plate Supplies, Inconel 600 Plates Manufacturer Stockist In Mumbai, India. Inconel 600 Plates, Alloy 600 Sheets, Inconel UNS N06600 Plates, ASME SB 168 Plate, JIS NCF 600 Plate, 600 Inconel Hot Rolled Plates Supplier In Mumbai, India.ASTM B 168 Inconel 600 Shim Sheets, Inconel Werkstoff No 2.4816 Sheets, Inconel 600 Cold Rolled Plates, 600 Alloy Plate Exporter, Inconel 600 Sheets Dealer In India.',
      text3:"This Inconel 600 sheets and plates is made using incomparable top tier material most recent structures continuing after the set models of industry. Our gave Inconel 600 Plates and Coils, Foils is bankrupt down on quality frameworks in order to make certain its enormity.",
  
      Specifications:
        {
            grade:'Inconel Alloy 600 / UNS N06600',
            Specifications : "ASTM B168 / ASME SB168",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.01 mm to 250 mmThk",
            Form : "Shim Sheet, Foils, Rolls, Chequered Plate, Flats, Designer Sheet, Blank (Circle), Strip, Plain Sheet, Coils, Ring (Flange) etc.",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
            applications:'Gas Processing, Specialty Chemicals, Pulp, Paper Off-Shore Oil Drilling Companies, Power Generation, Petrochemicals, Pharmaceuticals, Pharmaceutical Equipment, Chemical Equipment, Sea Water Equipment, Heat Exchangers, Condensers, Industry'
        }
      ,
      
      
      chemical:
  
        {
          Grade:'Inconel 600',
          c:'0.15 max',
          Mn:'1.00 max',
          Si:'0.50 max',
          P:'0.060 max',
          S:'0.015max',
          Cr:'14.00 – 17.00',
          Fe:'6.00 – 10.00',
          Ni:'72.00 min	',
          Cu:'0.50 max',
          
        }
      ,
      
    },
   
  ]

  export const Inconel718Data=[


    {
      text1:'Inconel 718 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'Inconel 718 Plates, Alloy 718 Sheets, ASME SB 670 Inconel 718 Plate, JIS NCF 718 Plate, Inconel UNS N07718 Plates,718 Inconel Hot Rolled Plates Supplier In Mumbai, India. ASTM B 670 Inconel 718 Shim Sheets, Inconel Werkstoff No 2.4668 Sheets, Inconel 718 Cold Rolled Plates, 718 Alloy Plate Exporter, Inconel 718 Sheets Dealer In India. 718 Inconel Plate Stockholder, 718 Inconel Polished Cold Drawn Plates, Inconel 718 Strips Stockist, Manufacturer.',
      text3:"Inconel Alloy 718 Sheet And Plates is being fused explicit assessments of essential worth standard ranges and meets its terms through national guidelines and by and large measures. We supply and charge wide dimension of UNS N07718 Plates that are passed on from high examination and quality foul material by our confided in experts.",
  
      Specifications:
        {
            Grade:'Inconel Alloy 718 / UNS N07718',
            Specifications : "ASTM B168 / ASME SB168",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.01 mm to 250 mmThk",
            Form : "Shim Sheet, Foils, Rolls, Chequered Plate, Flats, Designer Sheet, Blank (Circle), Strip, Plain Sheet, Coils, Ring (Flange) etc.",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
            applications:'Gas Processing, Specialty Chemicals, Pulp, Paper Off-Shore Oil Drilling Companies, Power Generation, Petrochemicals, Pharmaceuticals, Pharmaceutical Equipment, Chemical Equipment, Sea Water Equipment, Heat Exchangers, Condensers, Industry'
        }
      ,
      
      
      chemical:{
          Grade:'Inconel 718',
          c:'0.08 max',
          Mn:'0.35 max',
          Si:'0.35 max',
          P:'0.060 max',
          S:'0.015max',
          Cr:'17.00 – 21.00',
          Fe:'-',
          Ni:'50.00 – 55.00',
          Cu:'0.30 max',
          
        }
      ,
      
    },
   
  ]

  export const Inconel625Data=[


    {
      text1:'Inconel 625 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'Inconel 625 Plates, Alloy 625 Sheets, ASME SB443 Inconel 625 Plate, Inconel UNS N06625 Plates, JIS NCF 625 Plate, Inconel 625 Circle, 625 Inconel Hot Rolled Plates Supplier In Mumbai, India. 625 Alloy Plate Exporter, ASTM B 443 Inconel 625 Shim Sheets, Inconel Werkstoff No 2.4856 Sheets, Inconel Alloy 625 Coils, Inconel 625 Cold Rolled Plates, Inconel 625 Sheets Dealer In India. 625 Inconel Polished Cold Drawn Plates, Distributors Of ASME SB443 Inconel 625 Coils, 625 Inconel Plate Stockholder.',
      text3:"These, Inconel Alloy 625 Sheets, 625 Inconel Coils, Inconel 600 Plates is routinely used in Building objects dividers, Railways, Network leaves in strip malls, Decorative showroom, ventilation sort out, Highways, Environmental perplexity control squares, Generator room, in grain checking, in flood hour gridlock city working conditions, etc.",
  
      Specifications:
        {
            Specifications : "ASTM / ASME SB 168",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.01 mm to 250 mmThk",
            Form : "Shim Sheet, Foils, Rolls, Chequered Plate, Flats, Designer Sheet, Blank (Circle), Strip, Plain Sheet, Coils, Ring (Flange) etc.",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
            applications:'Gas Processing, Specialty Chemicals, Pulp, Paper Off-Shore Oil Drilling Companies, Power Generation, Petrochemicals, Pharmaceuticals, Pharmaceutical Equipment, Chemical Equipment, Sea Water Equipment, Heat Exchangers, Condensers, Industry'
        }
      ,
      
      
      chemical:
  
        {
          Grade:'Inconel 625',
          c:'0.10 max',
          Mn:'0.50 max',
          Si:'0.50 max',
          P:'0.060 max',
          S:'0.015max',
          Cr:'20.0 – 23.0',
          Fe:'5.0 max',
          Ni:'58.0 min',
          Cu:'-',
          
        }
      ,
      
    },
   
  ]

  export const Inconel706Data=[


    {
      text1:'Inconel 706 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'Inconel 706 UNS N09706 is precipitation-solidifying compound of nickel-chromium-iron, rapidly made and machinable, that outfits high mechanical quality in blend with astonishing fabricability. The properties of the amalgam take after those of Inconel blend 718 adjacent to that compound 706 is by and large more rapidly made, especially by machining.',
      text3:"Inconel amalgam 706 is utilized for a social event of occupations that require high bore joined suitably of creation. In the flight field, the mix is utilized for turbine plates, shafts, and cases; diffuser cases; blower circles and shafts; motor mounts; and catch. Notwithstanding flying applications, the compound is utilized for turbine plates in liberal mechanical gas turbines.",
  
      Specifications:
        {
            Grade:'Inconel Alloy 706 / UNS N09706',
            Specifications : "ASTM B168 / ASME SB163",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.01 mm to 250 mmThk",
            Form : "Shim Sheet, Foils, Rolls, Chequered Plate, Flats, Designer Sheet, Blank (Circle), Strip, Plain Sheet, Coils, Ring (Flange) etc.",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
            applications:'Gas Processing, Specialty Chemicals, Pulp, Paper Off-Shore Oil Drilling Companies, Power Generation, Petrochemicals, Pharmaceuticals, Pharmaceutical Equipment, Chemical Equipment, Sea Water Equipment, Heat Exchangers, Condensers, Industry'
        }
      ,
      
      
      chemical:
  
        {
          Grade:'Inconel 706',
          c:'.08 max',
          Mn:'0.35 max',
          Si:'0.35 max',
          S:'0.015max',
          Cr:'0.30 max',
          Fe:'-',
          Ni:'50.00 – 55.00',
          Cu:'0.30 max',
        
        
          
        }
      ,
      
    },
   
  ]

  export const Inconel750Data=[


    {
      text1:'Inconel 750 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'Inconel UNS N07750 Sheets, Inconel UNS N07750 Plates, Inconel Werkstoff Nr. 2.4669 Plates, Inconel DIN 2.4669 Sheets, Inconel 750 Plates Supplier In Mumbai, India. AMS 5542 Inconel Alloy Plain Plates Stockholder, Alloy X-750 Hot Rolled Plates, Inconel Sheets Stockist, Inconel X-750 Werkstoff No 2.4669 Sheets, Stockist Of Inconel 750 Plates, Alloy X-750 Shim Sheets, Specialist Of Inconel Alloy X-750 Slatting Coils, X-750 Inconel Alloy Plate Exporter, X-750 Inconel Polished Cold Drawn Plates, Leading Supplier Of Inconel X-750 Plate Dealer In India.',
      text3:"Inconel 750 Plates is utilized for Aircraft structures, Nuclear reactors, Rocket motors, Heat treat foundations, etc. In gas turbines,Alloy 750 Plate is utilized for rotor sharp edges and wheels, incapacitates, and other central individuals. Nickel 750 Sheets is a Nickel-Chromium mix made precipitation hardenable by amplifications of Al and Ti, having creep-break quality at high temperatures to around 700 Degree C (1290 Degree F).",
  
      Specifications:
        {
            Specifications : "ASTM B670 / ASME SB670",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.01 mm to 250 mmThk",
            Form : "Shim Sheet, Foils, Rolls, Chequered Plate, Flats, Designer Sheet, Blank (Circle), Strip, Plain Sheet, Coils, Ring (Flange) etc.",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
            applications:'Gas Processing, Specialty Chemicals, Pulp, Paper Off-Shore Oil Drilling Companies, Power Generation, Petrochemicals, Pharmaceuticals, Pharmaceutical Equipment, Chemical Equipment, Sea Water Equipment, Heat Exchangers, Condensers, Industry'
        }
      ,
      
      
      chemical:
  
        {
          Grade:'Inconel 750',
          c:'.08 max',
          Mn:'1.00 max',
          Si:'.50 max',
          P:'0.060 max',
          S:'.01 max',
          Cr:'14.0-17.0',
          Fe:'5.0-9.0',
          Ni:'70.0 min',
          Cu:'0.50 max',
          Co:'1.00 max',
          Nb:'0.70-1.20',
          Ti:'2.25-2.75',
          Al:'0.40-1.0'
          
        }
      ,
      
    },
   
  ]

  export const InconelRA330Data=[
    {
      text1:'Inconel RA330 Sheets & Plates Exporters,Suppliers,Importers,Stockists In Mumbai and India.',
      text2:'ASME SB 168 Incoloy 330 Plate, Incoloy Alloy SS 330 Coils, Incoloy SS 330 Circle, Incoloy 330 Plates, JIS NCF Incoloy SS 330 Plate, Incoloy UNS N08330 Plates, Alloy Ra 330 Sheets, Ra 330 Incoloy Hot Rolled Plates Supplier In Mumbai, India. ASTM B 168 Incoloy® 330 Shim Sheets, Incoloy Ra 330 Sheets, Inconel SS 330 Circle, Incoloy 330 Cold Rolled Plates, Inconel 330 Slatting Coil, SS 330 Alloy Plate Exporter, Incoloy Werkstoff Nr. 1.4886 Sheets Dealer In India.',
      text3:"Ra 330 Sheets moreover has unprecedented enemy of – breaking down and oxidation properties. With a nickel substance of 34 percent to 37 percent, Ra 330 Plates remains amazingly impervious to both chloride stress isolating splitting and embrittlement from the precipitation of sigma plan. Slow speeds, positive feeds, sulphureted prescriptions and inflexible mounts are by and large supported for Ra 330 Coils.",
  
      Specifications:
        {
            Specifications : "ASTM / ASME SB 168",
            Size : "1000 mm x 2000 mm, 1220 mm x 2440 mm, 1500 mm x 3000 mm, 2000 mm x 2000 mm, 2000 mm x 4000 mm",
            Thickness : "0.1mm to 12 mm Thk",
            Form : "Shim Sheet, Foils, Rolls, Chequered Plate, Flats, Designer Sheet, Blank (Circle), Strip, Plain Sheet, Coils, Ring (Flange) etc.",
            Finish : "Hot rolled plate (HR), Cold rolled sheet (CR), 2B, 2D, BA NO(8), SATIN (Met with Plastic Coated)",
            Hardness : "Soft, Hard, Half Hard, Quarter Hard, Spring Hard etc.",
            applications:'Gas Processing, Specialty Chemicals, Pulp, Paper Off-Shore Oil Drilling Companies, Power Generation, Petrochemicals, Pharmaceuticals, Pharmaceutical Equipment, Chemical Equipment, Sea Water Equipment, Heat Exchangers, Condensers, Industry'
        }
      ,
      
      
      chemical:
  
        {
          Grade:'Inconel 330',
          c:'.08 max',
          Mn:'2.00 max',
          Si:'0.75-1.50',
          S:'0.03 max',
          Cr:'17.0-20.0',
          Fe:'Balance',
          Ni:'34.0-37.0',
          Cu:'1.00 max',
          Sn:'0.025',
          Pb:'0.005 max'
          
        }
      ,
      
    },
   
  ]